module.exports = require("./classCallCheck.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/helpers/class-call-check.js
 ** module id = 276
 ** module chunks = 1
 **/